import { Expose } from 'class-transformer';

export default class RefundFormError {
    employment_id: string[] = []
    description: string[] = []
    nurse_fees: string[] = []
    locumloop_fees: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}